import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceatmumbaiiternationalairport() {



  const cardData =
  {
    keyword: 'Taxi Service at Mumbai International Airport',
    heading: 'Shambhu Cabs: Taxi Service at Mumbai International Airport',
    headingDescription: 'Shambhu Cabs offers dependable Taxi Service at Mumbai International Airport, ensuring safe, comfortable, and hassle-free pickups and drops for travelers arriving at or departing from Chhatrapati Shivaji Maharaj International Airport (T1 & T2). Whether you are a frequent flyer, corporate traveler, family, or tourist, our fleet of hatchbacks, sedans, SUVs, and premium vehicles provides a smooth and timely airport travel experience. With professional chauffeurs, flight-tracking support, 24/7 availability, and doorstep drop services across Mumbai, Thane, and Navi Mumbai, Shambhu Cabs ensures a seamless and stress-free airport transfer. For those looking for reliability, punctuality, and comfort, Shambhu Cabs is the trusted choice for taxi service at Mumbai International Airport.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch built to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it stands as a historic entry point for British governors and a symbol of colonial-era architecture. Today, visitors enjoy ferry rides to Elephanta Island, street food stalls, coastal photography, and a lively promenade filled with tourists, performers, and vendors. Its illuminated evenings create a stunning waterfront ambiance that reflects the essence of Mumbai."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s famous 3.6 km-long coastline, known for its curved boulevard that glitters like a ‘Queen’s Necklace’ at night. The promenade is ideal for morning jogs, romantic walks, cycling, and enjoying refreshing sea breezes. The Art Deco buildings lining the stretch add heritage value, making it one of the world’s largest collections of Art Deco architecture. Sunsets here are especially mesmerizing, drawing locals, tourists, and photographers to soak in the city’s vibrant coastal charm."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is an architectural masterpiece blending Victorian Gothic Revival and Indian traditional designs. Built in 1887, it is one of India’s busiest railway stations and a symbol of Mumbai’s historic importance. Its grand domes, stained glass windows, carvings of flora and fauna, and intricate pillars make it a living museum. The nighttime lighting further enhances its majesty, making it a must-visit landmark for history, architecture, and photography enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its vibrant street food culture, local entertainers, and stunning sunsets. Visitors indulge in Mumbai’s iconic snacks like pav bhaji, bhel puri, and gola while enjoying camel rides, kite flying, and beach sports. The beach is also frequently visited by Bollywood celebrities who live in the surrounding areas. Its lively yet relaxed atmosphere makes it a perfect escape for families, couples, and tourists."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, believed to fulfill devotees’ wishes. The temple’s wooden doors depict Ashtavinayak carvings, and the gold-plated sanctum adds to its spiritual aura. Thousands queue up daily for darshan, including celebrities and leaders. During Ganesh Chaturthi, the entire area comes alive with devotional music, lights, and vibrant processions, showcasing Mumbai’s deep spiritual culture."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on an islet connected by a narrow causeway, is a stunning Indo-Islamic structure honoring Sufi saint Pir Haji Ali Shah Bukhari. Surrounded by the sea on all sides, it offers breathtaking views and a serene spiritual experience. The white marble structure, religious hymns, and peaceful setting attract visitors of all faiths. The walk to the dargah during low tide is a unique experience, blending spirituality with natural beauty."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site located on Elephanta Island, feature ancient rock-cut sculptures dedicated primarily to Lord Shiva. The 5th–8th century caves include magnificent carvings like the massive Trimurti (three-faced Shiva), Nataraja, and various mythological scenes. Visitors reach the island via ferry from the Gateway of India, experiencing a combination of history, art, nature, and coastal adventure."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel that connects Mumbai’s western suburbs to South Mumbai. Its cable-stayed architecture, sweeping curves, and views of the Arabian Sea make it a visual delight. The bridge significantly reduces travel time, symbolizing Mumbai’s modern urban growth. The best time to view the Sea Link is during sunrise, sunset, or night when the bridge lights create a spectacular skyline view."
  },
  {
    "title": "Chor Bazaar",
    "description": "One of India’s oldest and most famous flea markets, Chor Bazaar is known for its antique furniture, vintage Bollywood posters, cameras, gramophones, lamps, and rare collectibles. Walking through its busy lanes offers a glimpse into Mumbai’s historic trade culture. Bargain hunters, interior designers, and collectors frequent the area to discover unique treasures. It remains a buzzing hotspot for culture, photography, and old-world charm."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread over 100 sq km, Sanjay Gandhi National Park is Mumbai’s green lung and a biodiversity hotspot. Visitors enjoy nature trails, lion and tiger safaris, boating, cycling routes, and the ancient Kanheri Caves inside the park. Home to leopards, deer, monkeys, and hundreds of bird species, it offers a jungle retreat in the middle of the city. The park is perfect for trekking, wildlife photography, and peaceful nature escapes."
  },
  {
    "title": "Mount Mary Church",
    "description": "The Basilica of Our Lady of the Mount, popularly called Mount Mary Church, is located atop a hill in Bandra offering beautiful views of the sea. The church is known for its stunning Gothic architecture, peaceful interiors, and the annual Bandra Fair held in September. Devotees across religions visit to seek blessings, light candles, and enjoy the serene surroundings. It is one of Mumbai’s most significant spiritual and cultural landmarks."
  }
],




"services": [
  {
    "name": "Mumbai Airport Taxi",
    "description": "Mumbai Airport Taxi provides reliable and comfortable taxi services to and from Mumbai Airport. Ideal for business travelers, tourists, and daily commuters, this service ensures timely pickups and drop-offs, professional drivers, and well-maintained vehicles for a smooth airport journey."
  },
  {
    "name": "Airport Pickup Taxi Mumbai",
    "description": "Airport Pickup Taxi Mumbai offers hassle-free pickups from Mumbai Airport terminals. With experienced chauffeurs, clean and AC-equipped cars, and 24×7 availability, passengers can reach their destination safely, comfortably, and on time, whether traveling locally or to nearby cities."
  },
  {
    "name": "Airport Drop Taxi Mumbai",
    "description": "Airport Drop Taxi Mumbai ensures punctual and convenient drop services to Mumbai Airport. Suitable for early morning flights or last-minute trips, this service provides well-maintained sedans and SUVs, professional drivers, and transparent pricing for stress-free travel."
  },
  {
    "name": "T2 Taxi Service Mumbai",
    "description": "T2 Taxi Service Mumbai specializes in transportation to and from the Mumbai T2 terminal. Passengers benefit from reliable pickups, prompt arrivals, courteous drivers, and clean vehicles, making travel to the airport or city seamless and convenient at any hour."
  },
  {
    "name": "Airport Prepaid Taxi Mumbai",
    "description": "Airport Prepaid Taxi Mumbai offers convenient prepaid taxi services for travelers who prefer fixed fares. With transparent pricing, no hidden charges, and comfortable, air-conditioned vehicles, passengers can enjoy secure and reliable travel to and from Mumbai Airport."
  },
  {
    "name": "Affordable Airport Taxi Mumbai",
    "description": "Affordable Airport Taxi Mumbai provides budget-friendly taxi services without compromising comfort or safety. Passengers can choose AC or non-AC cars for airport transfers, local travel, or outstation trips, with clear fare estimates and professional drivers ensuring a hassle-free experience."
  },
  {
    "name": "24×7 Airport Taxi",
    "description": "24×7 Airport Taxi ensures round-the-clock availability for airport transfers in Mumbai. Passengers can rely on timely pickups, experienced drivers, and well-maintained vehicles for safe, convenient, and punctual travel at any time of day or night."
  },
  {
    "name": "Best Airport Taxi Mumbai",
    "description": "Best Airport Taxi Mumbai offers premium and dependable airport cab services. With professional drivers, clean and comfortable vehicles, and prompt service, this service guarantees a smooth, stress-free journey to or from Mumbai Airport for business travelers, tourists, and families."
  },
  {
    "name": "AC Airport Taxi Mumbai",
    "description": "AC Airport Taxi Mumbai provides comfortable air-conditioned cabs for airport transfers. Whether traveling solo, with family, or in a group, passengers can enjoy professional drivers, well-maintained cars, and a safe, timely ride to Mumbai Airport or the city."
  },
  {
    "name": "Mumbai International Terminal Taxi",
    "description": "Mumbai International Terminal Taxi caters specifically to travelers using the international terminal. With experienced chauffeurs, clean vehicles, and quick bookings, this service ensures smooth, reliable, and stress-free transfers between Mumbai Airport and the city or nearby areas."
  },
  {
    "name": "Fast Airport Cab Mumbai",
    "description": "Fast Airport Cab Mumbai offers quick and efficient taxi services to and from the airport. With prompt pickups, optimized routes, and professional drivers, passengers can save time while enjoying safe, comfortable, and reliable travel in Mumbai."
  },
  {
    "name": "Online Airport Taxi Mumbai",
    "description": "Online Airport Taxi Mumbai enables passengers to book airport taxis conveniently through a website or app. Offering immediate confirmations, transparent pricing, and AC sedans or SUVs, this service ensures seamless travel to or from Mumbai Airport at any time."
  },
  {
    "name": "Sedan Airport Taxi Mumbai",
    "description": "Sedan Airport Taxi Mumbai provides comfortable and stylish sedan cars for airport transfers. Professional drivers, clean and AC-equipped vehicles, and timely pickups ensure passengers experience a safe, convenient, and stress-free ride to or from Mumbai Airport."
  },
  {
    "name": "SUV Airport Taxi",
    "description": "SUV Airport Taxi offers spacious and premium SUVs for airport transfers, family travel, or group trips. With professional chauffeurs, well-maintained vehicles, and 24×7 service, passengers enjoy a comfortable and reliable ride to and from Mumbai Airport."
  },
  {
    "name": "Corporate Airport Taxi Mumbai",
    "description": "Corporate Airport Taxi Mumbai provides specialized airport transfer services for business travelers and corporate clients. With punctual drivers, premium sedans and SUVs, and flexible billing, companies and executives can ensure safe, timely, and professional transport to and from Mumbai Airport."
  },
  {
    "name": "Safe Airport Taxi Service",
    "description": "Safe Airport Taxi Service Mumbai prioritizes passenger safety during airport transfers. With experienced drivers, real-time tracking, well-maintained vehicles, and 24×7 availability, travelers can enjoy secure, reliable, and stress-free rides to or from Mumbai Airport."
  },
  {
    "name": "Airport Transfer Mumbai",
    "description": "Airport Transfer Mumbai offers seamless transportation to and from Mumbai Airport. Whether for business, leisure, or family travel, this service provides experienced drivers, clean AC vehicles, flexible booking options, and timely pickups and drops for a comfortable and hassle-free journey."
  }
],

"tableData": [
  ["Mumbai Airport Taxi", "Airport Pickup Taxi Mumbai"],
  ["Airport Drop Taxi Mumbai", "T2 Taxi Service Mumbai"],
  ["Airport Prepaid Taxi Mumbai", "Affordable Airport Taxi Mumbai"],
  ["24×7 Airport Taxi", "Best Airport Taxi Mumbai"],
  ["AC Airport Taxi Mumbai", "Mumbai International Terminal Taxi"],
  ["Fast Airport Cab Mumbai", "Online Airport Taxi Mumbai"],
  ["Sedan Airport Taxi Mumbai", "SUV Airport Taxi"],
  ["Corporate Airport Taxi Mumbai", "Safe Airport Taxi Service"],
  ["Airport Transfer Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Taxi Service at Mumbai International Airport with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable taxi services at Mumbai International Airport, perfect for airport transfers, business trips, and convenient city travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs to ensure a smooth and comfortable journey from Mumbai Airport."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Airport Transfers",
    "WhyChoosedescription": "Our professional drivers are punctual and knowledgeable about airport routes, ensuring timely and hassle-free transfers."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear, upfront pricing—fuel, tolls, and driver allowances included—making your airport taxi experience stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, flight schedules, and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized airport transfer plans suited to your schedule and needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your airport taxi ride in Mumbai convenient and worry-free."
  }
]



























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide taxi service at Mumbai International Airport?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable taxi services at Mumbai International Airport for pickups, drop-offs, and onward travel across Mumbai and beyond.',
  },
  {
    question: 'How can I book a taxi at Mumbai International Airport with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for seamless airport taxi bookings.',
  },
  {
    question: 'What types of vehicles are available for airport taxi service in Mumbai?',
    answer: 'Shambhu Cabs provides sedans, SUVs, and premium cars suitable for individual travelers, families, and groups from the airport.',
  },
  {
    question: 'Are drivers experienced for airport taxi services in Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and well-acquainted with Mumbai and surrounding routes to ensure a timely and safe journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for airport taxi service?',
    answer: 'Absolutely. You can select your preferred pickup point at the airport and your desired drop-off location anywhere in Mumbai or nearby cities.',
  },
  {
    question: 'Is airport taxi service available 24x7 at Mumbai International Airport?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock taxi service at Mumbai International Airport to accommodate all flight schedules.',
  },
  {
    question: 'Are safety and hygiene protocols followed for airport taxi services?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict hygiene and safety measures for passenger well-being.',
  },
  {
    question: 'What payment options are available for airport taxi service in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for airport taxi bookings.',
  },
  {
    question: 'Is customer support available during airport taxi journeys?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your taxi journey from Mumbai International Airport.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehta',
    feedback: 'Shambhu Cabs made my airport pickup and drop-off very smooth and hassle-free. The driver was professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Singh',
    feedback: 'Highly satisfied with Shambhu Cabs’ taxi service at Mumbai International Airport. Clean car, comfortable ride, and excellent service.',
    rating: 5,
  },
];




























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service at Mumbai International Airport",
  "image": "https://www.shambhucab.com/assets/images/mumbai-airport-taxi.jpg",
  "description": "Shambhu Cabs provides reliable taxi services at Mumbai International Airport (T2). Book affordable AC sedans, SUVs, and prepaid taxis for airport pickups, drop-offs, corporate travel, and outstation trips, available 24×7 with safe and fast service.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "900",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-international-airport-taxi"
  }
};





  return (
    <div>

<Helmet>
  <title>Taxi Service at Mumbai International Airport | T2 Pickup & Drop | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book reliable taxi service at Mumbai International Airport (T2) with Shambhu Cabs. AC sedans, SUVs, prepaid taxis for airport pickup and drop. 24×7 safe, fast, and affordable service."
  />

  <meta
    name="keywords"
    content="Mumbai Airport Taxi, Airport Pickup Taxi Mumbai, Airport Drop Taxi Mumbai, T2 Taxi Service Mumbai, Airport Prepaid Taxi Mumbai, Affordable Airport Taxi Mumbai, 24×7 Airport Taxi, Best Airport Taxi Mumbai, AC Airport Taxi Mumbai, Mumbai International Terminal Taxi, Fast Airport Cab Mumbai, Online Airport Taxi Mumbai, Sedan Airport Taxi Mumbai, SUV Airport Taxi, Corporate Airport Taxi Mumbai, Safe Airport Taxi Service, Airport Transfer Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxiserviceatmumbaiiternationalairport;